<visio-dialog
  [okButton]="true"
  [showModal]="showDialog()"
  (showModalChange)="onCloseDialog()"
  [minWidth]="'600px'"
>
  <ng-container slot="title">{{ card().title }}</ng-container>

  <ng-container slot="body">
    <visio-tabs
      [tabs]="tabs()"
      [selected]="selectedTab()"
      (change)="selectedTab.set($event)"
    ></visio-tabs>
    <div class="inner-body">
      @switch (selectedTab().value) {
        @case ('details') {
          <div class="wrapper">
            <div class="start-column">
              <div class="detail-section">
                @for (field of cardFields(); track field.id) {
                  <div class="field-row">
                    <strong class="field-name">{{ field.label }}:</strong>
                    <span class="field-value">{{ field.value || 'N/A' }}</span>
                  </div>
                }
                <div class="field-row">
                  <strong class="detail-label">Prazo:</strong>
                  <span class="detail-value">{{
                    (card().dueDate | date: 'dd/MM/yyyy') || 'N/A'
                  }}</span>
                </div>
              </div>

              @if (tags().length > 0) {
                <div class="detail-section">
                  <strong class="detail-label">Tags</strong>
                  <div class="tags-container">
                    @for (tag of tags(); track tag) {
                      <span class="tag">{{ tag }}</span>
                    }
                  </div>
                </div>
              }
            </div>

            <div class="end-column">
              <div class="detail-section">
                <strong class="detail-label">ID:</strong>
                <div class="detail-value description">{{ card().id }}</div>
              </div>

              <div class="detail-section">
                <strong class="detail-label">Fase:</strong>
                <div class="detail-value description">{{ cardPhaseName() }}</div>
              </div>

              <div class="detail-section">
                <strong class="detail-label">Responsável:</strong>
                <span class="detail-value description">{{
                  card().assignedTo?.name || 'Não atribuído'
                }}</span>
              </div>
              <div class="detail-section">
                <strong class="detail-label">Loja:</strong>
                <span class="detail-value description">{{ card().shopName }}</span>
              </div>
              <div class="detail-section">
                <strong class="detail-label">Câmera:</strong>
                <span class="detail-value description">{{ card().cameraName }}</span>
              </div>
              <div class="detail-section">
                <strong class="detail-label">Criado em:</strong>
                <span class="detail-value description">{{ cardCreatedAt() }}</span>
              </div>
            </div>
          </div>
        }
        @case ('history') {
          <app-card-history [card]="card()"></app-card-history>
        }
        @case ('forms') {
          <app-card-form-submissions [card]="card()"></app-card-form-submissions>
        }
      }
    </div>
  </ng-container>
</visio-dialog>
